import React, { useState, useEffect, useCallback } from 'react';
import { fmt, api } from '../utils/api';

export default function FeedbackAdmin() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState('new');

  const load = useCallback(async () => {
    try {
      const data = await api.getFeedback();
      setItems(data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    try {
      await api.updateFeedbackStatus(id, status);
      setItems((list) => list.map((i) => (i.id === id ? { ...i, status } : i)));
    } catch (err) {
      console.error(err);
    }
  };

  if (!items) return null;

  const shown = filter === 'all' ? items : items.filter((i) => i.status === filter);
  const newCount = items.filter((i) => i.status === 'new').length;

  return (
    <div style={styles.panel}>
      <div style={styles.header}>
        <h2 style={styles.title}>
          💬 Feedback {newCount > 0 && <span style={styles.badge}>{newCount} new</span>}
        </h2>
        <div style={styles.filterTabs}>
          {['new', 'reviewed', 'done', 'all'].map((f) => (
            <button
              key={f}
              style={{ ...styles.filterTab, ...(filter === f ? styles.filterTabActive : {}) }}
              onClick={() => setFilter(f)}
            >
              {f[0].toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {shown.length === 0 ? (
        <p style={styles.empty}>Nothing here.</p>
      ) : (
        <div style={styles.list}>
          {shown.map((item) => (
            <div key={item.id} style={styles.row}>
              <div style={styles.rowTop}>
                <span style={styles.who}>
                  {item.user_name || 'Unknown'} · {item.household_name || ''}
                  {item.page_context && <span style={styles.pageTag}> · {item.page_context}</span>}
                </span>
                <span style={styles.date}>{fmt.shortDate(item.created_at)}</span>
              </div>
              <p style={styles.message}>{item.message}</p>
              <div style={styles.actions}>
                {item.status !== 'reviewed' && (
                  <button style={styles.actionBtn} onClick={() => setStatus(item.id, 'reviewed')}>Mark Reviewed</button>
                )}
                {item.status !== 'done' && (
                  <button style={{ ...styles.actionBtn, color: '#00d4aa', borderColor: '#00d4aa' }} onClick={() => setStatus(item.id, 'done')}>Mark Done</button>
                )}
                {item.status !== 'new' && (
                  <button style={styles.actionBtn} onClick={() => setStatus(item.id, 'new')}>Reopen</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  panel: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.5rem',
    marginBottom: '1rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
    flexWrap: 'wrap',
    gap: '0.5rem',
  },
  title: {
    margin: 0,
    fontSize: '1rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  badge: {
    background: '#ef4444',
    color: '#fff',
    fontSize: '0.65rem',
    fontWeight: '700',
    padding: '2px 8px',
    borderRadius: '999px',
  },
  filterTabs: { display: 'flex', gap: '0.3rem' },
  filterTab: {
    background: 'transparent',
    border: '1px solid #1e2a3a',
    color: '#6b7280',
    borderRadius: '999px',
    padding: '4px 10px',
    fontSize: '0.7rem',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
  },
  filterTabActive: {
    background: 'rgba(0, 212, 170, 0.12)',
    borderColor: '#00d4aa',
    color: '#00d4aa',
  },
  empty: { color: '#4b5563', fontSize: '0.85rem', textAlign: 'center', padding: '1rem 0' },
  list: { display: 'flex', flexDirection: 'column', gap: '0.6rem' },
  row: {
    background: '#0a0f1e',
    border: '1px solid #1e2a3a',
    borderRadius: '10px',
    padding: '0.85rem 1rem',
  },
  rowTop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0.4rem',
  },
  who: {
    color: '#9ca3af',
    fontSize: '0.72rem',
    fontFamily: "'Syne', sans-serif",
  },
  pageTag: { color: '#4b5563' },
  date: {
    color: '#4b5563',
    fontSize: '0.7rem',
    fontFamily: "'DM Mono', monospace",
  },
  message: {
    color: '#e5e7eb',
    fontSize: '0.85rem',
    lineHeight: '1.5',
    margin: '0 0 0.6rem',
  },
  actions: { display: 'flex', gap: '0.4rem' },
  actionBtn: {
    background: 'transparent',
    border: '1px solid #1e2a3a',
    color: '#9ca3af',
    borderRadius: '6px',
    padding: '4px 10px',
    fontSize: '0.7rem',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
  },
};
